import { apiService } from '@/services/APIService';

export default {
  getVotes(params) {
    return apiService.get('/votes', params);
  },
  getPublicVotes(params) {
    return apiService.get('/public/votes', params);
  },
  getVote(id, params) {
    return apiService.get(`/votes/${id}`, params);
  },
  createVote(params) {
    return apiService.post('/votes', params);
  },
  updateVote(id, params) {
    return apiService.put(`/votes/${id}`, params);
  },
  deleteVote(id) {
    return apiService.delete(`/votes/${id}`);
  },
  attachPollJournals(id, params) {
    return apiService.post(`/votes/${id}/attach-poll-journals`, params);
  },
  detachPollJournals(id, params) {
    return apiService.post(`/votes/${id}/detach-poll-journals`, params);
  },
  voteForWorks(id, params) {
    return apiService.post(`/votes/${id}/user-vote`, params);
  },
  userPublicVoting(id, params) {
    return apiService.post(`/public/votes/${id}/user-vote`, params);
  },
  getUserVotes(params) {
    return apiService.get('/votes/user-votes', params);
  },
  getVotesStats(id, params) {
    return apiService.get(`/votes/${id}/stats`, params);
  },
  getRandomJournal(id, params) {
    return apiService.get(`/votes/${id}/random-poll-journal`, params);
  },
  getPublicJournals(id, params) {
    return apiService.get(`/public/votes/${id}/poll-journals`, params);
  },
  markAsViewed(voteId, journalId) {
    return apiService.post(`votes/${voteId}/poll-journal-views/${journalId}`);
  },
};
